import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CreateJobHeader.scss';
import {
	useDispatch,
	useSelector
} from 'react-redux';
import { AppState } from '../../store/state/appState';
import { EngagementExpandedSummary } from '../../models/dto/engagement';
import { AppDispatch } from '../../store/actions/appDispatch';
import { loadEngagementIfMissing } from '../../store/actions/engagementsActions';
import BackToTethrLink from '../BackToTethrLink';

export default function CreateJobHeader(props: CreateJobHeaderProps) {
	const engagement = useSelector<AppState, EngagementExpandedSummary | undefined>(s => s.engagements.details.get(props.engagementId));
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		dispatch(loadEngagementIfMissing(props.engagementId));
	}, [props.engagementId]);
	
	return (
		<React.Fragment>
			<div className="create-job-header__outer-container">
				<div className="create-job-header__inner-container">
					<div className="create-job-header__job-name">
						<h3 className="ellipsis">{props.jobName}</h3>
					</div>
					{props.progressStatus !== 'none' &&
						<div className="create-job-header__progress-container">
							<div className={getProgressItemClasses('select')}>SELECT</div>
							<div className={getProgressItemClasses('map')}>MAP</div>
							<div className={getProgressItemClasses('upload')}>UPLOAD</div>
						</div>
					}
					<div className="create-job-header__close">
						{!!engagement && !engagement.showTethrAppIntegration && <Link to={`/engagements/${props.engagementId}`}>Close</Link>}
						{!!engagement && engagement.showTethrAppIntegration && <BackToTethrLink tethrUrl={engagement?.tethrUrl} linkText="Back to Creovai" />}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
	
	function getProgressItemClasses(type: CreatJobProgressStatus): string {
		const classes: string[] = ['create-job-header__progress-item'];
		const idx = getProgressItemIndex(type);
		const activeIndex = getProgressItemIndex(props.progressStatus);
		
		if (idx === activeIndex) {
			classes.push('create-job-header__progress-item_active');
		} else if (idx < activeIndex) {
			classes.push('create-job-header__progress-item_was-active');
		}
		
		return classes.join(' ');
	}
	
	function getProgressItemIndex(type: CreatJobProgressStatus): number {
		switch (type) {
			case 'none':
				return -1;
			case 'select':
				return 1;
			case 'map':
				return 2;
			case 'upload':
				return 3;
		}
	}
}

export interface CreateJobHeaderProps {
	engagementId: number;
    jobName: string;
    progressStatus: CreatJobProgressStatus;
}

export type CreatJobProgressStatus = 'select' | 'map' | 'upload' | 'none';
